/* Gallery media handling.
   Some product photos are animated WebP around 1.9MB. Assigning one straight to
   #hero-main-img.src blanked the frame for the whole download - several seconds on
   mobile data. These helpers decode the next photo off-screen first so the photo on
   screen stays put until the replacement is ready to paint.
   Prefetching is intent-driven only (hover, or the touch that starts a tap/swipe);
   nothing heavy is fetched speculatively on page load. */
var wnxImgCache = {};
var wnxHeroWanted = null;
var wnxHeroToken = 0;

function wnxPreload(src) {
  if (!src) return Promise.resolve();
  if (wnxImgCache[src]) return wnxImgCache[src];
  var img = new Image();
  var p = new Promise(function (resolve) {
    img.onload = function () {
      /* decode() moves the work off the main thread so the swap cannot jank */
      if (img.decode) { img.decode().then(resolve, resolve); } else { resolve(); }
    };
    img.onerror = resolve; /* a broken asset must never block the swap */
    img.src = src;
  });
  wnxImgCache[src] = p;
  return p;
}

/* Respect data-saver and very slow links - those shoppers should only ever
   download the photo they actually opened. */
function wnxMayPrefetch() {
  var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  if (!c) return true;
  if (c.saveData) return false;
  return !/2g$/.test(c.effectiveType || '');
}

function wnxThumbs() {
  return [].slice.call(document.querySelectorAll('.wnx-lp .thumb'));
}

function wnxActiveIdx(list) {
  for (var k = 0; k < list.length; k++) {
    if (list[k].getAttribute('data-active') === 'true') return k;
  }
  return 0;
}

/* Swap the hero photo without ever showing an empty frame. */
function wnxShowHero(src) {
  var main = document.getElementById('hero-main-img');
  if (!main || !src || src === wnxHeroWanted) return;
  wnxHeroWanted = src;
  var token = ++wnxHeroToken;
  var settled = false;
  /* Only dim once the wait is noticeable, so cached swaps stay flicker-free. */
  var dim = setTimeout(function () {
    if (!settled && token === wnxHeroToken) {
      main.style.transition = 'opacity .18s ease';
      main.style.opacity = '0.55';
    }
  }, 160);
  wnxPreload(src).then(function () {
    settled = true;
    clearTimeout(dim);
    if (token !== wnxHeroToken) return; /* a newer swap already won the race */
    main.src = src;
    main.style.transition = 'opacity .18s ease';
    main.style.opacity = '1';
  });
}

function wnxSwitchThumb(btn) {
  wnxThumbs().forEach(function (t) { t.setAttribute('data-active', 'false'); });
  btn.setAttribute('data-active', 'true');
  /* The poster fills the box first; the video (if any) fades in over it. */
  wnxShowHero(btn.getAttribute('data-src'));
  if (btn.getAttribute('data-kind') === 'video') { wnxEnterVideo(); } else { wnxLeaveVideo(); }
}

function wnxSelectBundle(card) {
  document.querySelectorAll('.wnx-lp .bundle-card').forEach(function (c) {
    c.setAttribute('data-selected', 'false');
  });
  card.setAttribute('data-selected', 'true');
  var hero = card.getAttribute('data-hero-img');
  if (!hero) return;
  wnxThumbs().forEach(function (tb) { tb.setAttribute('data-active', 'false'); });
  wnxLeaveVideo();
  wnxShowHero(hero);
}

(function () {
  function bind() {
    var thumbs = wnxThumbs();
    if (!thumbs.length) return;
    /* Hovering or touching a thumbnail is a clear signal the shopper is about to
       open it - start the download during that gap. */
    thumbs.forEach(function (t) {
      var warm = function () {
        if (wnxMayPrefetch()) wnxPreload(t.getAttribute('data-src'));
      };
      t.addEventListener('mouseenter', warm, { passive: true });
      t.addEventListener('touchstart', warm, { passive: true });
    });
    /* Touching the main photo usually precedes a swipe, so warm the slots on
       either side of the current one while the finger is still down. */
    var wrap = document.querySelector('.wnx-lp .hero-image-wrap');
    if (wrap) {
      wrap.addEventListener('touchstart', function () {
        if (!wnxMayPrefetch()) return;
        var list = wnxThumbs();
        var i = wnxActiveIdx(list);
        [i + 1, i - 1].forEach(function (n) {
          if (list[n]) wnxPreload(list[n].getAttribute('data-src'));
        });
      }, { passive: true });
    }
  }
  if (document.readyState !== 'loading') bind();
  else document.addEventListener('DOMContentLoaded', bind);
})();

function wnxFaqToggle(btn){var item=btn.closest(".faq-item"),open=item.getAttribute("data-open")==="true";item.setAttribute("data-open",open?"false":"true")}function wnxScrollToBundle(){var el=document.getElementById("bundle-section");el&&el.scrollIntoView({behavior:"smooth"})}function wnxAddToCart(){var selected=document.querySelector('.wnx-lp .bundle-card[data-selected="true"]');if(!selected){alert("Please select a bundle first.");return}var variantId=selected.getAttribute("data-variant"),items=[{id:parseInt(variantId,10),quantity:1}],upCb=document.getElementById("wnx-upsell-cb");if(upCb&&upCb.checked){var upVar=upCb.getAttribute("data-upsell-variant");upVar&&items.push({id:parseInt(upVar,10),quantity:1})}var btn=document.getElementById("wnx-main-cta"),originalHTML=btn?btn.innerHTML:"";function setLoading(on){btn&&(btn.disabled=on,on?btn.innerHTML='<span class="block font-bold cta-headline">Adding...</span>':btn.innerHTML=originalHTML)}setLoading(!0);var sections=["cart-drawer","cart-icon-bubble","cart-live-region-text"];fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json",Accept:"application/javascript"},body:JSON.stringify({items:items,sections:sections.join(","),sections_url:window.location.pathname})}).then(function(r){return r.json().then(function(j){return{ok:r.ok,data:j}})}).then(function(res){if(!res.ok)throw new Error(res.data&&res.data.description||"add failed");var rendered=res.data.sections||{};if(rendered["cart-icon-bubble"]){var bubble=document.getElementById("cart-icon-bubble");if(bubble){var parser=new DOMParser,doc=parser.parseFromString(rendered["cart-icon-bubble"],"text/html"),newBubble=doc.querySelector(".shopify-section")||doc.body.firstElementChild;newBubble&&(bubble.innerHTML=newBubble.innerHTML)}}var cartDrawer=document.querySelector("cart-drawer");if(cartDrawer&&rendered["cart-drawer"]){var p2=new DOMParser,doc2=p2.parseFromString(rendered["cart-drawer"],"text/html"),newDrawer=doc2.querySelector("cart-drawer");newDrawer&&(cartDrawer.innerHTML=newDrawer.innerHTML,cartDrawer.classList.remove("is-empty"))}var cartDrawerSection=document.querySelector('[id^="shopify-section-"][id*="cart-drawer"]');cartDrawerSection&&(cartDrawerSection.style.display="block",cartDrawerSection.style.visibility="visible");var d=document.querySelector("cart-drawer");d&&typeof d.open=="function"?d.open():d?(d.classList.add("active"),d.removeAttribute("aria-hidden"),document.body.classList.add("overflow-hidden")):window.location.href="/cart",setLoading(!1)}).catch(function(err){console.error("[WildNightX] add-to-cart failed, falling back to permalink:",err),window.location.href="/cart/"+variantId+":1"})}

/* Video slot support.
   A gallery slot can be a Shopify video. Its poster travels through the same smooth
   swap as any photo, so the box is filled immediately; the <video> then fades in on
   top and loops muted. Nothing about the video is fetched until the shopper shows
   intent, so page load is unaffected. */
function wnxVideoEl() { return document.getElementById('hero-main-video'); }

function wnxVideoWarm() {
  var v = wnxVideoEl();
  if (!v || v.preload !== 'none') return;
  v.preload = 'auto';
  v.load();
}

function wnxEnterVideo() {
  var v = wnxVideoEl();
  if (!v) return;
  var play = document.getElementById('hero-video-play');
  wnxVideoWarm();
  v.setAttribute('data-shown', 'true');
  /* Shoppers who asked their OS for less motion get a still with a play control. */
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    if (play) play.hidden = false;
    return;
  }
  var p = v.play();
  /* Autoplay can still be refused - iOS Low Power Mode is the common case. */
  if (p && p.catch) p.catch(function () { if (play) play.hidden = false; });
}

function wnxLeaveVideo() {
  var v = wnxVideoEl();
  if (!v) return;
  var play = document.getElementById('hero-video-play');
  if (play) play.hidden = true;
  v.removeAttribute('data-shown');
  try { v.pause(); } catch (e) {}
}

(function () {
  function bind() {
    var play = document.getElementById('hero-video-play');
    if (play) {
      play.addEventListener('click', function () {
        var v = wnxVideoEl();
        if (!v) return;
        play.hidden = true;
        v.play().catch(function () { play.hidden = false; });
      });
    }
    /* Warm the video on the same intent signals used for photos. */
    document.querySelectorAll('.wnx-lp .thumb[data-kind="video"]').forEach(function (t) {
      t.addEventListener('mouseenter', wnxVideoWarm, { passive: true });
      t.addEventListener('touchstart', wnxVideoWarm, { passive: true });
    });
    var wrap = document.querySelector('.wnx-lp .hero-image-wrap');
    if (wrap) wrap.addEventListener('touchstart', wnxVideoWarm, { passive: true });
  }
  if (document.readyState !== 'loading') bind();
  else document.addEventListener('DOMContentLoaded', bind);
})();
